import { adminApiRequest } from "./admin-api-client";
import type {
  WheelCatalogTemplateId,
  WheelConfigV1,
  WheelTemplatePreviewColors,
} from "../types/wheel";

export interface WheelTemplateDefaultsResponse {
  templateId: WheelCatalogTemplateId;
  saved: boolean;
  wheelConfig: WheelConfigV1;
  previewColors: WheelTemplatePreviewColors;
}

export function fetchWheelTemplateDefaults(
  templateId: string
): Promise<WheelTemplateDefaultsResponse> {
  return adminApiRequest<WheelTemplateDefaultsResponse>(
    `/admin/wheel-templates/${encodeURIComponent(templateId)}`
  );
}

export function updateWheelTemplateDefaults(
  templateId: string,
  body: { wheelConfig: WheelConfigV1; previewColors: WheelTemplatePreviewColors }
): Promise<WheelTemplateDefaultsResponse> {
  return adminApiRequest<WheelTemplateDefaultsResponse>(
    `/admin/wheel-templates/${encodeURIComponent(templateId)}`,
    {
      method: "PATCH",
      body: JSON.stringify(body),
    }
  );
}
